// extracted by mini-css-extract-plugin
export default {"footer__container":"Footer_footer__container__IzvFy","mb_15px":"Footer_mb_15px__fmtqk","mb_20px":"Footer_mb_20px__qmnwn"};